(() => {
  const initArticleEnhancements = () => {
    document.querySelectorAll('[data-article-layout]').forEach((layout) => {
      if (layout.dataset.enhancementsReady === 'true') return;
      layout.dataset.enhancementsReady = 'true';

      const body = layout.querySelector('[data-article-body]');
      const toc = layout.querySelector('[data-article-toc]');
      const tocNav = layout.querySelector('[data-article-toc-nav]');
      if (!body || !toc || !tocNav) return;

      const headings = [...body.querySelectorAll('h2, h3')].filter((heading) => !heading.closest('[data-no-toc]'));
      if (headings.length < 2) return;

      const usedIds = new Set();
      const list = document.createElement('ol');

      headings.forEach((heading, index) => {
        let baseId = heading.id || heading.textContent
          .trim()
          .toLocaleLowerCase()
          .normalize('NFKD')
          .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
          .replace(/^-+|-+$/g, '');

        if (!baseId) baseId = `section-${index + 1}`;
        let uniqueId = baseId;
        let suffix = 2;
        while (usedIds.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
          uniqueId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        usedIds.add(uniqueId);
        heading.id = uniqueId;

        const item = document.createElement('li');
        item.className = `toc-level-${heading.tagName.substring(1)}`;
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(uniqueId)}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });

      tocNav.replaceChildren(list);
      toc.hidden = false;
      layout.classList.add('has-toc');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleEnhancements, { once: true });
  } else {
    initArticleEnhancements();
  }

  document.addEventListener('shopify:section:load', initArticleEnhancements);
})();
